export default function Datenschutz() {
  return (
    <div className="min-h-screen py-16 md:py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-10">
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-foreground-700">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Verantwortlicher
            </h2>
            <p>
              Verantwortlicher für die Datenverarbeitung auf dieser Website ist:
            </p>
            <div className="mt-3 space-y-1">
              <p className="font-semibold text-foreground-900">Klosek Metallbau GmbH</p>
              <p>Römerweg 15</p>
              <p>58513 Lüdenscheid</p>
              <p>E-Mail: info@klosek-metallbau.de</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Erhebung und Speicherung personenbezogener Daten
            </h2>
            <p>
              Beim Besuch dieser Website werden keine personenbezogenen Daten erhoben, es sei denn, Sie stellen uns diese freiwillig zur Verfügung (z.B. durch Kontaktaufnahme per E-Mail oder Telefon).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Zweck der Datenverarbeitung
            </h2>
            <p>
              Die von Ihnen bereitgestellten Daten werden ausschließlich zur Bearbeitung Ihrer Anfragen und zur Auftragsabwicklung verwendet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Weitergabe von Daten
            </h2>
            <p>
              Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur, wenn dies zur Erfüllung unserer vertraglichen Pflichten erforderlich ist oder gesetzliche Vorschriften dies vorsehen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Ihre Rechte
            </h2>
            <p>
              Sie haben das Recht auf Auskunft über die bei uns gespeicherten personenbezogenen Daten, deren Berichtigung oder Löschung, sowie das Recht auf Einschränkung der Verarbeitung und auf Datenübertragbarkeit. Sie können der Verarbeitung Ihrer Daten jederzeit widersprechen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Cookies
            </h2>
            <p>
              Diese Website verwendet Cookies, um Ihnen ein optimales Online-Erlebnis bieten zu können. Durch die Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies einverstanden. Sie können Ihre Browser-Einstellungen so ändern, dass Cookies nicht gespeichert werden.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
              Änderungen dieser Datenschutzerklärung
            </h2>
            <p>
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren. Die aktuelle Version ist stets auf dieser Website einsehbar.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}